import LocalizedStrings from "react-localization";
let strings = new LocalizedStrings({
  en: {
    workview: "Previous Work",
    ads: "Ads",
    // common
    eventCreator: "Event Creator",
    Filmshow: "Show For Film",
    showcreatedat: "Creation Date",
    showDescrip: "Show Description",
    noshows: "There is no Shows",
    currentLocation: "Location",
    FilmImage: "Film Image",
    searchRegion: "Search for Regions ...",
    loading: "Loading ...",
    show: "Show",
    preview: "Preview",
    table: "Table",
    card: "Card",
    comingSoon: "Coming Soon",
    call: "Call",
    mailing: "Mail",
    LastActivities: "Latest Shows",
    username: "Name",
    Retry: "Retry",
    NoExist: "No Exsit",
    loadMore: "Load More",
    readMore: "read More",
    confirm: "Confirm",
    CancelBTN: "Cancel",
    createBTN: "Create",
    Btn_Filter: "Filter",
    SendKey: "Send",
    addBTN: "Add",
    edittip: "Edit",
    deletetip: "Delete",
    details: "Details",
    viewtip: "Details",
    EditBTN: "Edit",
    // logout
    SingOut: "Sign Out",
    confirmation: "Are you sure you want to logout",
    logout: "Log Out",
    // Login
    loginKey: "Login",
    UserType: "User Type",
    AdminType: "Admin",
    SubAdminType: "Sub Admin",
    forgetPasswordKey: "Forget Password",
    EnterPassword: "Enter Your Password",
    EnterMail: "Enter Your Email",
    confirmpassword: "Confirm Password",
    CinemaType: "Cinema",
    EventType: "Event",
    // Login ====== BUTTON
    ReSendKey: "Re-Send Code",
    BackBtn: "Login",
    BackToEmail: "Back to change Email",
    // Login ====== ERROR MESSAGE
    networkError: "Network Error",
    emailError: "email is not correct",
    codeError: "the code is not correct",
    userError: "forbidden user",
    loginError: "Password or email is not correct",
    //Reports
    showRecords: "Showing Records",
    showAllRecords: "Show All Records",
    // Rules
    rule: "Rules",
    //User Profile
    adminJob: "Admin",
    memberSince: "Member Since",
    profile: "Profile",
    EditReqDone: "Edited Successfully",

    // User
    activate: "Activate",
    deactivate: "Deactivate",
    activateed: "Active",
    deactivated: "Not Active",
    activationTitle: "Activate Account",
    deactivationTitle: "Deactivate Account",
    activationAlert: "Are you sure you want to Activate account",
    deactivationAlert: "Are you sure you want to Deactivate account",
    name: "Name",
    image: "Image",
    video: "Video",
    type: "Type",
    // Reports
    reports: "Reports",
    selectfilter: "Select Filteration",
    datefilter: "Date Filter",
    selectyear: "Select Year",
    selectmonth: "Select Month",
    colsfilter: "Cols Filter",
    searchby: "Search By",
    EditBTN: "Edit",
    Roles: "Roles",
    personalInfo: "Personal Information",
    SubAdminImage: "Sub Admin Image",
    email: "Email",
    phone: "Phone Number",
    status: "Status",
    RegesteredDate: "Registered Date",
    RegesteredFrom: "Registered Since",
    years: "year",
    month: "month",
    foryear: "for year",
    forMonth: "for month",
    // Clients
    address: "Address",
    Clientinfo: "Client",
    ClientWallet: "Wallet",
    ClientName: "Name",
    usermail: "Email",
    userphone: "Phone",
    status: "Status",
    createdat: "Created At",
    currency: "S.R",
    balance: "Balance",
    ClientReservation: "Reservations",
    NoReservations: "There are no Reservations",

    FilmCategory: "Film Category : ",
    ticketPricing: "Ticket Pricing ",
    AvailableticketPricing: "Available Tickets",
    reservationowner: "Reservation Owner",
    Desc: "Film Description : ",
    FilmDetails: "Film Details",
    locationShow: "Locations Show",
    LE: "R.S",
    ShowTime: "Show Times",
    From: "From",
    To: "To",
    charge: "Charge",
    reservations: "Reservations",
    TicketType: "Ticket Type",
    paymentmethod: "Payment Method",
    TicketPrice: "Ticket Price",
    Ticketfor: "Ticket for",
    ticket: "Ticket",
    entranceTime: "Entrance Time",
    reservationTime: "Reservation Time",

    filmtype: "Film Type",
    filmdesc: "Film Description",
    filmname: "Film Name",
    showname: "Show Name",
    showdes: "Show Description",

    //Cinema
    address: "Address",
    locationtitle: "Location",
    hallname: "Hall Name",
    numofchairs: "Number if Chairs",
    movieslist: "Movies showed in Hall",
    Cinemainfo: "Cinema",
    hall: "Hall",
    halls: "Halls",
    films: "Films",
    NoFilms: "There is no Films ",
    NoHalls: "No Halls Exist",
    // Event
    EventsLocation: "Event Location",
    Eventinfo: "About Event",
    Events: "Events",
    NoEvents: "There is no Events",
    //Notification
    notificationInfo: "Notification",
    description: "description",
    createdAt: "Date",
    Clients: "Clients",
    ShowDetails: "Show Location Details",
    ShowPlaceName: "Show Place Name ",
    showPlaceAlt: "Show Location Image",
    showPlaceDes: "Show location Description",
    locationOnMap: "Location On Map",
    offer: "Offer",
    NoOffer: "Nop Offer",
    NumberOfPlaces: "Number Of places",
    AddNewDate: "Add New Date",
    AddShowTitle: "Add Show Locations",
    EditShowTitle: "Edit Show Locations",
    ShowTime: "Show Timing",
    ticketPricingAfterOffer: "Ticket Pricing After Offer",
    since: "Since",
    validationTime: "Should Enter Date and Time",
    usersOf: "Category ",
    NoCinemainCategory: "No Cinemas In this Category",
    NoEventinCategory: "No Events In this Category",
    seatnumber: "Seat",
    ticketnumber: "Ticket Number",
    CASH: "Cash",
    WALLET: "From Wallet",
    CREDIT: "Credit Card",
    NoFilmsInHall: "No Shows In This Hall",
    NoShowEvents: "No Events In This Hall",
    NoShowLocation: "No Show Locations selected for this film",
    show: "Shows",
    numofshows: "Shows",
    numoffilms: "Films",
    numofhalls: "Halls",
    profit: "Profits",
    numofshares: "Shares",
    NoTickets: "No Tickets",
    TicketTypes: "Ticket Types : ",
    chooseTicketPrice: "Should Select Ticket Prices",
    capcity: "Capcity",
    Show: "Show",
    LatestShow: "Latest Show",
    EventNAme: "Event Name",
    EventDes: "Event Description",
    HallName: "Hall",
    NumOfChair: "Number Of Chairs",
    LocationOnMap: "Location On Map",
    // SendRoles:'Send Selected Roles',
    // SelectAllRoles:'Send All Roles',
    // UnSelectAllRoles:'Cancel All Roles',
    sendRules: "Send Selected Roles",
    selectAllRules: "Send All Roles",
    UnSelectAllRules: "Cancel All Roles",
    //Halls
    chairs: "chairs",
    noChairs: "No Chairs in Hall",
    LatestShow: "Latest Show",
    LastFilm: "Latest Film",
    chair: "chair number",
    allChairs: "Chairs",
    addChairs: "Add Chairs",
    editChairs: "Edit Chair number",
    ticketsPricing: " from ticket Pricing",
    notAssignedChairs: " notAssigned Chairs",
    AllFilms: "All Films",
    AllFilmsHint: "Available Films in System",
    numberOfPlacesError: "you must assign all chairs to ticket pricing type",
    film: "Film",
    chairunit: "chair",
    hour: "HH",
    Min: "MM",
    lastFiveEvent: "The Last Five Events",
    AllEvents: "All Events",
    EventLocation: "Events Locations",
    NumOFShare: "Number Of Shares",
    noShowTimes: "There ara no Show Times",
    cinemaName: "Cinema Name",
    Cinemareservations: "Cinema Reservation",
    Eventreservations: "Event Reservation",
    Reservation: "Reservations",
    hint: "Hint",
    hinttext: "Please distribution All chairs Among Ticket Categories",
    ticketpricingnote: "Please add Ticket Category First",
    yearErr: "Please Select The Year",
    monthErr: "Please Select The Month",
    colsErr: "Please Select The Columns",
    LatestMember: "Latest Clients",
    attachTicket: " Determine Ticket",
    ShowDate: "Show Date",
    validationError: "Invalid Date",
    ticketerror: "Please add Ticket Category First",
    Addticket: "Add Ticket Page",
    of: "Of",
    Offer: "Offer",
    rate: "Rate",
    TicketPriceAfterDiscount: "Total Price after discount",
    aboutus: "About Us",
    showLess: "Show Less",
    showMore: "Show More",
    ReservationSteps: "Reservation Steps",
    noReservationSteps: "No Reservation Steps",
    Addfilmtype: "Film Type Page",
    filmtypeerror: "Please, Add film type first",
    AddFilm: "Add Film",
    multiImgErrFlag: "please upload images for the slider",
    addVideo: "Add Video",
    videoErrFlag: "Upload video",
    ADVIRT: "ADS",
    noAdvirtisment: "No Ads added yet",
    showplacesEmpty: "Please add Show places ",
    Addhall: "Add Hall Page",
    addMultiImage: "Add Multi Image",
    hintMulti: "Internal photos (you can add more than one image)",
    hintone: "External Photo",
    addStep: "Add Step",
    add: "Add",
    edit: "Edit",
    enterStepAr: "(Enter Step (In Arabic",
    enterStepEn: "Enter Step (In English)",
    textEnerr: "Should enter step (In English) ",
    textArerr: "Should enter step (In Arabic) ",
    slider: "Slider",
    video: "Video",
    NoSlider: "No Images for slider",
    NoVideo: "No Video",
    EditFilm: "Edit Film",
    EditTouritPlace: "Edit Tourist Place",
    touristplacename: "Name",
    AddEntertainementActivity: "Add Entertainement Activity",
    cityname: "City Name",
    verificationAlert: "Are you sure you want to verify ?",
    RejectionAlert: "Are you sure you want to reject ?",
    convertToMyTicket: "Convert to my ticket",
    convertToTalent: "Convert to talent",
    accept: "Accept",
    reject: "Reject",
    waiting: "Waiting",
    AddOurShow: "Add Our Show",
    AddFreeShow: "Add Free Show",
    EditFreeShow: "Edit Free Show",
    ADVIRT: "Home Video",
    noAdvirtisment: "No Ads added yet",
    city: "City",
    tradingNumber: "Commercial Register",
    desCoperation: "Description Coperation",
    nameCoperation: "Trade Name",
    date: "Date",
    contactphone: "Contact phone",
    logo: "Logo",
    touristplaceDesc: "Description of the Touristical place",
    activity: "Description of the  Entertainement places ",
    joinToMyTicket: "Join to My ticket",
    works: "Works",
    noWorkAdded: "There is no work added yet",
    Cashierinfo: "Personal Info",
    tickets: "Tickets",
    selectCinema: "Select Cinema First",
    next: "Next",
    select: "Select",
    selectcinemaErr: "Please Select Cinema Name",
    selectOrganizer: "Select Event Organizer First",
    selectOrganizerErr: "Please Select Event Organizer",
    TalentWork: "Works of Talent",
    work: "Work",
    editBtn: "Edit",
    rate: "Rate",
    SecondIamvge: "Second Image",
    noWorks: "No Works",
    orderInfo: "Order Info",
    location: "Location",
    talentInfo: "Talent Info",
    talentname: "Talent Name",
    contactNumber: "Contact Number",
    typeOrder: "Order type",
    MORETHANMONTH: "More than one month",
    LessTHanMonth: "Less than one month",
    orderDate: "Order Date",
    reasonOrder: "Reason of order",
    CREDIT: "Credit",
    cinemaShouldHasTicketTypes: "Cinema Should has ticket types first",
    organizerShouldHasTicketTypes:
      "Event Organizer Should has ticket types first",
    organizerShouldHasHalls: "Event organizer should has halls",
    Requests: "Requests",
    Freereservations: "Free Reservation",
    reservationsWithTickets: "Reservations With tickets",
    deletevideo: "Delete video",
    comingSoon_Andriod: "Available on Andriod",
    comingSoon_ios: "Available on Ios",
    orderTime: "Order Time",
    ReservationsShow: "Reservations",
    freeShow: "Free SHows",
    ticketShow: "Shows via tickets",
    enterShow: "Entertainment Activites",
    touristplaces: "Tourist Places",
    editTalent: "Edit Talent",
    EditEventShow: "Edit Event Show",
    lightlogo: "Light Logo",
    darklogo: "Dark Logo",
    Rates: "Rates",
    loadMoree: "Load More",
    talentDesc: "Description of talent",
    talentType: "Talent Type",
    country: "Country",
    balance: "Balance",
    balanceRemove: "Transfere Money",
    report: "Report",
    selectAllChairs: "Select all chairs",
    changeTicketType: "Change ticket type",
    selectTicket: "Select Ticket",
    pleaseSelectTicktType: "Please Select ticket type",
    credit: "Credit",
    AdminBalance: "Admin Balance",
    CinemaBalance: "Cinema Balance",
    unit: "S.R",
    yes: "Yes",
    no: "No",
    History: "History",
    EvnetBalance: "Event Organizer balance",
    tickets: "tickets",
    noHostory: "No History",
    noBalance: "No Balance",
    MyTicketPortion: "My ticket portion",

    creditBalanceMyTicket: "Credit Balance",
    ticketCount: "Ticket count",
    transferCount: "Transfered",
    nottransferCount: "Un transfered",
    adminBalance: "Admin Balance",
    RemainingAdminBalance: "Remaining",
    orgBalance: "Event Organizer  Balance",
    RemainingOrgBalance: "Remaining",
    totalAmount: "Total amount",
    ticketinfo: "Ticket",
    ticketsinfo: "Tickets",
    admincat: "Admin",
    EventOrgCat: "Event Organizer",
    AllTicketsbalance: "All Tickets",
    RemainingCinemaBalance: "Cinema Balance",
    CinemaOrgCat: "Cinema",
    statusCurrent: "Status",
    finished: "Finished",
    largetDate: "Finished date",
    notFinished: "Not Finished",
    startDate: "Start Date",
    endDate: "End Date",
    DatesAndTimes: "Dates & Times",
    sat: "Saturday",
    mon: "Monday",
    sun: "Sunday",
    tue: "Tuesday",
    wednesday: "wednesday",
    thursday: "thursday",
    friday: "friday",
    Offer: "Offer",
    pm: "pm",
    am: "am",
    addTime: "Add Time",
    total: "Total",
    thetotal: "The total",
    admin: "Admin",
    cinemaTotalSummery: "Cinema",
    eventCreator: "Event Organizer",
    numberOfTYoes: "Number of types",
    addDateAndTime: "Add Date & Time",
    to: 'to',
    from: 'from',
    selectAttachChairs: 'Select Chairs',
    attachAutomaticChairErr:'Please choose accepted values',
    Count_Number: "Totoal Count: ",
  },
  ar: {
    Count_Number: "العدد الأجمالي",
    cinemaTotalSummery: "السينما",
    eventCreator: "مُنظم الفاعلية",
    admin: "الأدمن",
    thetotal: "الإجمالي",
    total: "إجمالي",
    numberOfTYoes: "عدد الفئات",
    pm: "مساءا",
    am: "صباحا",
    Offer: "خصم",
    to: 'الى',
    from: 'من',
    attachAutomaticChairErr:'من فضلك أدخال قيم صحيحة',
    selectAttachChairs: 'قم بتحديد الكراسي',
    addDateAndTime: "أضف وقت و تاريخ",
    addTime: "أضافة وقت",
    friday: "الجمعة",
    thursday: "الخميس",
    wednesday: "الاربعاء",
    tue: "الثلاثاء",
    sun: "الاحد",
    mon: "الاثنين",
    sat: "السبت",
    DatesAndTimes: "التواريخ و الأوقات",
    endDate: "نهاية التاريخ",
    startDate: "بداية التاريخ",
    largetDate: "تاريخ انتهاء العرض",
    notFinished: "غير منتهي",
    finished: "منتهي",
    statusCurrent: "الحالة",
    CinemaOrgCat: "السينما",
    RemainingCinemaBalance: "رصيد السينما",
    AllTicketsbalance: "جميع التذاكر",
    EventOrgCat: "منظم الفاعلية",
    admincat: "الادمن",
    ticketinfo: "تذكرة",
    ticketsinfo: "تذاكر",
    totalAmount: "إجمالي المبلغ",
    orgBalance: "رصيد منظم الفاعلية",
    RemainingOrgBalance: "متبقي له",
    adminBalance: "رصيد الادمن",
    RemainingAdminBalance: "متبقي له",
    nottransferCount: "لم يتم تحويل",
    transferCount: "تم تحويل",
    ticketCount: "عدد التذاكر",

    creditBalanceMyTicket: "الحاسبة",
    MyTicketPortion: "نصيب ماي تيكت",
    noBalance: "لا يوجد رصيد",
    noHostory: "لا يوجد أرشيف",
    tickets: "تذاكر",
    yes: "نعم",
    EvnetBalance: "رصيد الفاعلية",
    History: "أرشيف",
    no: "لا",
    CinemaBalance: "رصيد السينما",
    unit: "ريال",
    AdminBalance: "رصيد الادمن",
    credit: "الحاسبة",
    pleaseSelectTicktType: "من فضلك أختر نوع التذكرة",
    selectTicket: "أختر تذكرة",
    changeTicketType: "تغيير نوع التذاكر",
    selectAllChairs: "أختر كل الكراسي",
    report: "تقرير",
    balanceRemove: "تحويل الحساب",
    balance: "الحساب",
    country: "الدولة",
    talentType: "نوع الموهبة",
    talentDesc: "وصف الموهبة",
    loadMoree: "لإضف المزيد",
    Rates: "التقيمات",
    lightlogo: "الشعار الفاتح",
    darklogo: "الشعار الداكن",
    EditEventShow: "تعديل عرض الفاعلية",
    editTalent: "تعديل موهوب",
    touristplaces: "معالم سياحية",
    enterShow: "أنشطة ترفيهية",
    ticketShow: "عروض بالتذاكر",
    freeShow: "العروض المجانية",
    ReservationsShow: "الحجوزات",
    deletevideo: "حذف فيديو",
    orderTime: "وقت الطلب",
    reservationsWithTickets: "الحجوزات بالتذاكر",
    Freereservations: "الحجوزات المجانية",
    Requests: "الطلبات",
    organizerShouldHasHalls: "يجب علي مُتظم الفاعليات ادخال قاعات اولا",
    cinemaShouldHasTicketTypes: "يجب علي السينما إضافة انواع للتذاكر اولا",
    organizerShouldHasTicketTypes:
      "يجب علي مُنظم الفاعليات إضافة انواع للتذاكر اولا",
    CREDIT: "البطاقة الائتمانية",
    reasonOrder: "سبب الطلب",
    orderDate: "تاريخ الطلب",
    LessTHanMonth: "أقل من شهر",
    MORETHANMONTH: "أكثر من شهر",
    typeOrder: "نوع الطلب",
    contactNumber: "رقم التواصل",
    talentname: "أسم الموهوب",
    location: "الموقع",
    talentInfo: "معلومات الموهوب",
    orderInfo: "معلومات الطلب",
    noWorks: "لا يوجد أعمال",
    SecondIamvge: "الصورة التانية",
    rate: "تقيم",
    editBtn: "تعديل",
    work: "العمل",
    TalentWork: "أعمال الموهوب",
    workview: "إعمال سابقة",
    selectOrganizerErr: "من فضلك أختر منظم الفاعليات",
    selectOrganizer: "أختر منظم الفاعليات أولا",
    selectcinemaErr: "من فضلك أختر اسم السينما",
    select: "أختر",
    next: "التالي",
    selectCinema: "أختر السينما أولا",
    tickets: "التذاكر",
    Cashierinfo: "البيانات الشخصية",
    works: "الاعمال",
    noWorkAdded: "لا يوجد اعمال سابقة",
    joinToMyTicket: "مُنضم ل My ticket",
    activity: "وصف النشاط الترفيهي",
    touristplaceDesc: "وصف المعلم السياحي",
    AddOurShow: "أضافة عرض",
    AddFreeShow: "أضف عرض مجاني",
    EditFreeShow: "تعديل عرض مجاني",
    reject: "مرفوض",
    waiting: "قيد الانتظار",
    accept: "مقبول",
    convertToTalent: "تحويل لموهوب",
    convertToMyTicket: " اكتشاف My Ticket",
    RejectionAlert: "هل انت متاكد انك تريد رفض ؟",
    verificationAlert: "هل انت متاكد انك تريد قبولة ؟",
    AddEntertainementActivity: "أضف نشاط ترفيهي",
    cityname: "أسم المدينة",
    touristplacename: "الاسم",
    EditTouritPlace: "تعديل المعلم السياحي",
    EditFilm: "تعديل الفيلم",
    NoVideo: "لا يوجد فيديو",
    NoSlider: "لا يوجد صور متحركة",
    video: "فيديو",
    slider: "الصور المتحركة",
    textEnerr: "يجب ادخال الخطوة (باللغة الانجليزية)",
    textArerr: "يجب ادخال الخطوة (باللغة العربية)",
    enterStepEn: "أدخل الخطوة (باللغة الانجليزية)",
    enterStepAr: "أدخل الخطوة (باللغة العربية)",
    edit: "تعديل",
    add: "أضف",
    addStep: "إضافة خطوة",
    showplacesEmpty: "من فضلك اضف أماكن العرض",
    Addhall: "صفحة إضافة مكان عرض",
    videoErrFlag: "أضف فيديو",
    addMultiImage: "إضف صور متحركة",
    hintMulti: "صور داخلية ( يمكنك اضافة اكثر من صورة )",
    hintone: " الصورة الخارجية",
    addVideo: "أضف فيديو",
    multiImgErrFlag: "من فضلك اضف صور",
    AddFilm: "أضف فيلم",
    filmtypeerror: "من فضلك أضف نوع للافلام اولا",
    Addfilmtype: "صفحة نوع للفيلم",

    logo: "الشعار",
    contactphone: "رقم التواصل",
    nameCoperation: "الاسم التجاري",
    date: "التاريخ",
    desCoperation: "وصف منشأة",
    tradingNumber: "السجل التجاري",
    city: "المدينة",
    noAdvirtisment: "لا يوجد اعلانات",
    ADVIRT: "فيديو الرئيسية",
    ads: "الاعلان",
    noReservationSteps: "لا يوجد خطوات للحجز",
    ReservationSteps: "خطوات الحجز",
    showMore: " رؤية المزيد",
    showLess: "رؤية أقل",
    TicketPriceAfterDiscount: "السعر بعد الخصم",
    aboutus: "من نحن",
    rate: "تقيم",
    Offer: "الخصم",
    of: "من",
    Addticket: "صفحةأضافة فئات التذاكر ",
    ticketerror: " من فضلك قم بأدخال فئات التذاكر أولا ",
    validationError: "الموعد غير صحيح",
    ShowDate: "مواعيد العرض",
    attachTicket: "تحديد  نوع التذكرة",
    colsErr: "من فضلك اختار الاعمدة",
    monthErr: "من فضلك اختار الشهر",
    yearErr: "من فضلك اختار السنة",
    ticketpricingnote: "من فضلك أدخل فئات التذاكر أولا",
    Reservation: "الحجوزات",
    hint: "ملحوظة",
    hinttext: "من فضلك قم بتوزيع جميع الكراسي علي فئات التذاكر",
    Eventreservations: "حجوزات الفاعليات",
    Cinemareservations: "حجوزات السينما",
    eventCreator: "منظم الفاعلية",
    cinemaName: "اسم السينما",
    noshows: " لا يوجد عروض",
    showcreatedat: "تاريخ الأنشاء",
    Filmshow: "عرض لفيلم",
    showDescrip: "وصف العرض",

    chairunit: "كرسي",
    // Common
    // Common
    noShowTimes: "لم يتم تحديد اوقات للعرض",
    NumOFShare: "عدد مرات المشاركة",
    EventLocation: "مواقع الفاعليات",
    lastFiveEvent: "اخر خمس فاعليات",
    AllEvents: "كل الفاعليات",
    hour: "ساعة",
    Min: "دقيقة",
    sendRules: "ارسال الصلاحيات المختارة",
    selectAllRules: "اختيار كل الصلاحيات",
    UnSelectAllRules: "الغاء كل الصلاحيات",
    LocationOnMap: "العنوان علي الخريطة",
    NumOfChair: "عدد الكراسي",
    HallName: "القاعة",
    EventDes: "وصف الفاعلية",
    EventNAme: "اسم الفاعلية",
    LatestShow: "أحدث العروض",
    Show: "العرض",
    capcity: "السعة",
    chooseTicketPrice: "يجب اختيار اسعار التذاكر",
    TicketTypes: "انواع التذاكر : ",
    NoTickets: "لا توجد تذاكر",
    NoShowLocation: "لم يتم تحديد اماكن عرض لهذا الفيلم ",
    comingSoon_Andriod: "حاليا بالاندرويد",
    comingSoon_ios: "حاليا بال IoS",
    call: "الأتصال",
    mailing: "البريد الالكتروني",
    film: "الفيلم",
    AllFilmsHint: "جميع الأفلام المتاحة بالمنظومة",
    AllFilms: "جميع الأفلام",
    LastFilm: "أحدث الأفلام",
    LatestShow: "أحدث العروض",
    currentLocation: "الموقع",
    FilmImage: "صورة الفيلم",
    show: "العرض",
    table: "جدول",
    card: "كاردات",
    preview: "سلايدر",
    NoShowLocation: "لم يتم تحديد اماكن عرض لهذا الفيلم ",

    searchRegion: "البحث عن المنطقة ...",
    loading: "جاري التحميل...",
    NoShowEvents: "لا توجد فاعليات في هذه القاعة",
    NoFilmsInHall: "لا توجد عروض في هذه القاعه",
    comingSoon: "قريبا",
    call: "الأتصال",
    mailing: "البريد الالكتروني",
    NoShowEvents: "لا توجد فاعليات في هذه القاعة",
    NoFilmsInHall: "لا توجد عروض في هذه القاعه",
    NoCinemainCategory: "لا يوجد سينيمات في هذه الفئة",
    NoEventinCategory: "لا يوجد فعليات في هذه الفئة",
    usersOf: "فئة",
    validationTime: "يجب ادخال الوقت و التاريخ",
    ticketPricingAfterOffer: "اسعار التذاكر بعد خصم",
    ShowTime: "اوقات العرض",
    AddShowTitle: "اضافة مكان عرض",
    EditShowTitle: "تعديل مكان عرض",
    AddNewDate: "اضافة معاد اخر",
    NumberOfPlaces: "عدد الكراسي",
    NoOffer: "لا يوجد خصم",
    offer: "خصم",
    locationOnMap: "الموقع علي الخريطة",
    showPlaceDes: "وصف مكان العرض",
    showPlaceAlt: "صورة لمكان العرض",
    ShowPlaceName: "اسم مكان العرض",
    ShowDetails: "تفاصيل مكان العرض",
    To: "الي",
    From: "من",
    ShowTime: "اوقات العرض",
    LE: "ريال",
    locationShow: "اماكن العرض",
    FilmDetails: "تفاصيل الفيلم",
    Desc: "وصف الفيلم : ",
    ticketPricing: "اسعار التذاكر ",
    AvailableticketPricing: "التذاكر المتاحة",
    reservationowner: "صاحب الحجز",
    FilmCategory: "فئة الفيلم :",
    RegesteredFrom: "موجود منذ",
    RegesteredDate: "تاريخ التسجيل",
    status: "الحالة",
    phone: "رقم الهاتف",
    email: "البريد الالكتروني",
    SubAdminImage: "صورة المسؤول",
    Roles: "الصلاحيات",
    personalInfo: "المعلومات الشخصية",
    EditBTN: "تعديل",
    LastActivities: "أحدث العروض ",
    LatestMember: "أحدث المستخدمين",

    username: "الأسم",
    RegesteredFrom: "موجود منذ",
    RegesteredDate: "تاريخ التسجيل",
    status: "الحالة",
    phone: "رقم الهاتف",
    email: "البريد الالكتروني",
    SubAdminImage: "صورة المسؤول",
    Roles: "الصلاحيات",
    personalInfo: "المعلومات الشخصية",
    EditBTN: "تعديل",
    username: "الأسم",
    Retry: "اعادة المحاولة",
    NoExist: "لا يوجد",
    loadMore: "تحميل المزيد",
    readMore: "قراءة المزيد",
    confirm: "تأكيد",
    CancelBTN: "ألغاء",
    createBTN: "انشاء",
    Btn_Filter: "البحث",
    SendKey: "ارسال",
    addBTN: "اضافة",
    edittip: "تعديل",
    deletetip: "حذف",
    details: "التفاصيل",
    viewtip: "التفاصيل",
    EditBTN: "تعديل",
    // logout
    SingOut: "خروج",
    confirmation: "هل تريد تسجيل الخروج",
    logout: "تسجيل الخروج",
    // Login
    loginKey: " تسجيل الدخول",
    UserType: "نوع المستخدم",
    AdminType: "مسؤول",
    SubAdminType: "مسؤول فرعي",
    forgetPasswordKey: "نسيت كلمة المرور",
    EnterPassword: "ادخل كلمة المرور",
    EnterMail: "ادخل البريد الاليكتروني",
    confirmpassword: "تاكيد كلمة المرور",
    CinemaType: "سينما",
    EventType: "فاعلية",
    // Login ====== BUTTON
    ReSendKey: "اعادة ارسال الكود",
    BackBtn: " تسجيل الدخول",
    BackToEmail: "العودة لتغيير الايميل",
    // Login ====== ERROR MESSAGE
    networkError: "خطأ فى الاتصال بالانترنت",
    emailError: "البريد الالكترونى  غير صحيح",
    codeError: "الرمز التاكيدي غير صحيح",
    userError: "هذا الحساب غير موجود",
    loginError: "البريد الالكترونى او كلمة المرور غير صحيحة",
    //Reports
    showRecords: "عرض ",
    showAllRecords: "عرض الكل",
    // Rules
    rule: "صلاحيات",
    //User Profile
    adminJob: "أدمن",
    memberSince: "عضو منذ",
    profile: "الصفحة الشخصية",
    EditReqDone: "تم التعديل بنجاح",
    // User
    activate: "تنشيط",
    deactivate: "تعطيل",
    activateed: "نشط",
    deactivated: "غير نشط",
    activationTitle: "تنشيط حساب",
    deactivationTitle: "تعطيل حساب",
    activationAlert: "هل أنت متأكد من تنشيط حساب",
    deactivationAlert: "هل أنت متأكد من تعطيل حساب",
    name: "الاسم",
    image: "صورة",
    video: "فيديو",
    type: "النوع",
    // Reports
    reports: "التقارير",
    selectfilter: "اختار التصفية",
    datefilter: "تصفية التاريخ",
    selectyear: "اختار السنة",
    selectmonth: "اختار الشهر",
    colsfilter: "تصفية الاعمدة",
    searchby: "البحث بواسطة",
    years: "السنة",
    month: "الشهر",
    foryear: "لسنة",
    forMonth: "لشهر",

    // Clients
    address: "العنوان",
    Clientinfo: "العميل",
    ClientWallet: "المحفظة",
    ClientName: "الأسم",
    usermail: "البريد الألكتروني",
    userphone: "رقم الهاتف",
    status: "الحالة",
    createdat: "تاريخ الأشتراك",
    currency: "ريال",
    balance: "الرصيد",
    ClientReservation: "الحجزات",
    NoReservations: "لا يوجد حجزات",

    charge: "الرصيد",
    reservations: "الحجوزات",
    TicketType: "نوع التذكرة",
    paymentmethod: "طريقة الدفع",
    TicketPrice: "سعر التذكرة",
    Ticketfor: "التذكرة لدخول",
    locationtitle: "موقعك",
    ticket: "التذكرة",
    entranceTime: "موعد الدخول",
    reservationTime: "موعد الحجز",

    filmtype: "نوع الفيلم",
    filmdesc: "وصف الفيلم",
    filmname: "اسم الفيلم",
    showname: "اسم العرض",
    showdes: "وصف العرض",
    //Cinema
    address: "العنوان",
    locationtitle: "الموقع",
    NoFilms: "لا يوجد أفلام ",

    hallname: "اسم القاعة",
    numofchairs: "عدد الكراسي",
    movieslist: "الافلام المعروضة في القاعة",
    Cinemainfo: "السينما",
    hall: "القاعة",
    halls: "القاعات",
    films: "أفلام",
    NoHalls: "لا يوجد قاعات",
    // Event
    EventsLocation: "أماكن الفعليات",
    Eventinfo: "عن الفاعلية ",
    Events: "الفاعليات",
    NoEvents: "لا يوجد فعليات",
    //Notification
    notificationInfo: "الاشعار",
    description: "النص",
    createdAt: "التاريخ",
    Clients: "العملاء",
    since: "منذ",

    seatnumber: "مقعد",
    ticketnumber: "رقم التذكرة",
    CASH: "نقدا",
    WALLET: " من المحفظة",
    CREDIT: " بالبطاقة الائتمانية",
    show: "العرض",
    numofshows: " العروض",
    numoffilms: " الافلام",
    numofhalls: " القاعات",
    profit: "الارباح",
    numofshares: " المشاركات",
    //Halls
    chairs: "الكراسى",
    noChairs: "لا يوجد كراسي بالقاعة ",
    chair: "كرسى رقم",
    allChairs: "الكراسى",
    addChairs: "إضافة الكراسى",
    editChairs: "تعديل الكرسى رقم ",
    ticketsPricing: " من الفئة ",
    notAssignedChairs: "الكراسى الغير محددة الفئة",
    numberOfPlacesError: "يجب تحديد فئة جميع الكراسى",
  },
});
export default strings;
